// الذكاء الصغير المتعلَّم من تاريخ المحفظة نفسها — بلا خوادم وبلا نماذج.
// هذا ما يجعل البُعد الثاني شبه مجاني: بعد أسبوعين تُختار الوجهة وحدها.

import { activeTypes, activeDests, liveEntries, stats } from './store.js';

const OUT = e => e.kind !== 'in';
const ts = e => new Date(e.occurredAt).getTime();

// العدّادات تأتي من الخادم وتُحدَّث محلياً عند كل كتابة (bumpStats)، فترتيب
// البنود يبقى صادقاً بلا اتصال دون حمل تاريخ المحفظة على الجهاز.
const byCount = (bag) => (a, b) => (bag[b.id] || 0) - (bag[a.id] || 0);

/** أكثر وجهة اقترنت بهذا النوع في تاريخ المحفظة. */
export function autoDestFor(typeId){
  if (!typeId) return null;
  const pairs = stats().pairs || {};
  let best = null, bestN = 0;
  for (const destId of Object.keys(pairs)){
    const n = pairs[destId][typeId] || 0;
    if (n > bestN){ bestN = n; best = destId; }
  }
  // لا نقترح وجهة مؤرشفة أو محذوفة
  return activeDests().some(d => d.id === best) ? best : null;
}

/** الأنواع مرتّبة حسب اقترانها بهذه الوجهة — الأرجح أولاً. */
export function likelyTypesFor(destId){
  const pairs = stats().pairs || {};
  const tally = destId
    ? (pairs[destId] || {})
    : Object.values(pairs).reduce((acc, row) => {
        for (const k of Object.keys(row)) acc[k] = (acc[k] || 0) + row[k];
        return acc;
      }, {});
  return activeTypes().slice().sort(byCount(tally));
}

/** الأنواع الأكثر استخداماً — تُستخدم في شاشة «يوم كامل». */
export function topTypes(n = 7){
  return activeTypes().slice().sort(byCount(stats().typesRecent || {})).slice(0, n);
}

/** الوجهات مرتّبة حسب الاستخدام الأخير — لتثبيت ذاكرة اليد. */
export function orderedDests(){
  return activeDests().slice().sort(byCount(stats().destsRecent || {}));
}

/** الأنواع مرتّبة حسب الاستخدام العام. */
export function orderedTypes(){
  return activeTypes().slice().sort(byCount(stats().typesRecent || {}));
}

/* أُزيلت usualAmounts و lastCurFor:
   - رقاقات المبالغ المعتادة حُذفت من شاشة الإدخال بطلب المستخدم.
   - العملة واحدة تُختار عند فتح الحساب، فلا حاجة لتذكّرها لكل وجهة.
   حقل currency باقٍ في قاعدة البيانات — القدرة محفوظة إن أُعيدت لاحقاً بلا هجرة. */

/** الحركات التي تنتظر تصنيفاً. */
/**
 * الحركات بلا نوع، أحدثها أولاً.
 * range اختياري: يقصر الكومة على فترة بعينها — يُستعمل حين يأتي المستخدم
 * من تنبيه تقرير فترة محدّدة، فلا نضعه أمام حركات شهر آخر لم يسأل عنها.
 */
export function untypedEntries(skip = [], range = null){
  const skipSet = new Set(skip);
  return liveEntries()
    .filter(e => OUT(e) && !e.typeId && !skipSet.has(e.id))
    .filter(e => !range || (ts(e) >= range.f && ts(e) <= range.t))
    .sort((a, b) => ts(b) - ts(a));
}
